import React from 'react';

const PronunciationSection = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row items-center justify-between bg-blue-500 text-white p-6 md:p-12">
        {/* Left Section */}
        <div className="max-w-lg mb-6 md:mb-0">
          <h1 className="text-2xl md:text-4xl font-bold mb-4">PRONUNCIATION</h1>
          <p className="text-base md:text-lg">
            Mastering the English pronunciation provides you with an edge to
            convey your message clearly across the board.
          </p>
        </div>

        {/* Right Section */}
        <div className="text-sm md:text-base space-y-4">
          <p className="border-b-2 border-white pb-2">Express yourself with ease</p>
          <p className="border-b-2 border-white pb-2">Make yourself understood</p>
          <p>Become a good listener</p>
        </div>
      </div>
    </>
  );
};

export default PronunciationSection;
